(function () {
    const mobileMedia = window.matchMedia('(max-width: 768px)');
    let resizeFrame = null;

    function equalizeContentHeight(slider) {
        const contents = Array.from(slider.querySelectorAll('.works-banner__content'));

        contents.forEach(function (content) {
            content.style.minHeight = '';
        });

        if (!mobileMedia.matches || contents.length < 2) return;

        const maxHeight = Math.max.apply(null, contents.map(function (content) {
            return content.getBoundingClientRect().height;
        }));

        contents.forEach(function (content) {
            content.style.minHeight = maxHeight + 'px';
        });
    }

    function equalizeAllContent() {
        document.querySelectorAll('[data-works-slider]').forEach(function (slider) {
            equalizeContentHeight(slider);

            if (slider.swiper) {
                slider.swiper.update();
            }
        });
    }

    function scheduleContentEqualization() {
        if (resizeFrame !== null) {
            window.cancelAnimationFrame(resizeFrame);
        }

        resizeFrame = window.requestAnimationFrame(function () {
            resizeFrame = null;
            equalizeAllContent();
        });
    }

    function initWorksSliders() {
        if (typeof window.Swiper !== 'function') return;

        document.querySelectorAll('[data-works-slider]').forEach(function (slider) {
            if (slider.swiper) return;

            const swiper = new window.Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 12,
                speed: 500,
                watchOverflow: true,
                keyboard: {
                    enabled: true,
                },
                pagination: {
                    el: slider.querySelector('.works-banner__pagination'),
                    clickable: true,
                },
                navigation: {
                    prevEl: slider.querySelector('.works-banner__arrow--prev'),
                    nextEl: slider.querySelector('.works-banner__arrow--next'),
                },
            });

            swiper.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.22, 1, 0.36, 1)';
        });

        scheduleContentEqualization();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWorksSliders);
    } else {
        initWorksSliders();
    }

    window.addEventListener('resize', scheduleContentEqualization);

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleContentEqualization);
    }
})();
